module.exports = __webpack_public_path__ + "img/selected1-min.1d709b49.png";